module.exports = __webpack_public_path__ + "images/emoji/telephone.c48bb7af3f6afdf42dd3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/telephone.png
// module id = HkBi
// module chunks = 14